import { _ as _call_super } from "@swc/helpers/_/_call_super";
import { _ as _class_call_check } from "@swc/helpers/_/_class_call_check";
import { _ as _inherits } from "@swc/helpers/_/_inherits";
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { toFormat } from './BoundFormat.js';
import { isMissingValue } from '../../api/Missing.js';
export var MissingFormat = /*#__PURE__*/ function() {
    "use strict";
    function MissingFormat(wrapped, options) {
        _class_call_check(this, MissingFormat);
        var _ref;
        Object.defineProperties(this, {
            format: {
                value: this.format.bind(this)
            },
            wrapped: {
                value: toFormat(wrapped)
            },
            missing: {
                value: (_ref = options === null || options === void 0 ? void 0 : options.missing) !== null && _ref !== void 0 ? _ref : ''
            }
        });
    }
    var _proto = MissingFormat.prototype;
    _proto.format = function format(value) {
        return isMissingValue(value) ? this.missing : this.wrapped.format(value);
    };
    _proto.resolvedOptions = function resolvedOptions() {
        return {
            missing: this.missing
        };
    };
    return MissingFormat;
}();
export var MissingFormatWithOptions = /*#__PURE__*/ function(MissingFormat) {
    "use strict";
    _inherits(MissingFormatWithOptions, MissingFormat);
    function MissingFormatWithOptions(wrapped, options) {
        _class_call_check(this, MissingFormatWithOptions);
        return _call_super(this, MissingFormatWithOptions, [
            wrapped,
            options
        ]);
    }
    var _proto = MissingFormatWithOptions.prototype;
    _proto.resolvedOptions = function resolvedOptions() {
        return _object_spread_props(_object_spread({}, this.wrapped.resolvedOptions()), {
            missing: this.missing
        });
    };
    return MissingFormatWithOptions;
}(MissingFormat);
export var MissingFormatToParts = /*#__PURE__*/ function(MissingFormatWithOptions) {
    "use strict";
    _inherits(MissingFormatToParts, MissingFormatWithOptions);
    function MissingFormatToParts(wrapped, options) {
        _class_call_check(this, MissingFormatToParts);
        return _call_super(this, MissingFormatToParts, [
            wrapped,
            options
        ]);
    }
    var _proto = MissingFormatToParts.prototype;
    _proto.formatToParts = function formatToParts(value) {
        if (isMissingValue(value)) {
            return [
                {
                    type: 'missing',
                    value: this.missing
                }
            ];
        }
        return this.wrapped.formatToParts(value);
    };
    return MissingFormatToParts;
}(MissingFormatWithOptions);
export var MissingFormatRange = /*#__PURE__*/ function(MissingFormatToParts) {
    "use strict";
    _inherits(MissingFormatRange, MissingFormatToParts);
    function MissingFormatRange(wrapped, options) {
        _class_call_check(this, MissingFormatRange);
        return _call_super(this, MissingFormatRange, [
            wrapped,
            options
        ]);
    }
    var _proto = MissingFormatRange.prototype;
    _proto.formatRange = function formatRange(start, end) {
        return this.wrapped.formatRange(start, end);
    };
    _proto.formatRangeToParts = function formatRangeToParts(start, end) {
        return this.wrapped.formatRangeToParts(start, end);
    };
    return MissingFormatRange;
}(MissingFormatToParts);

//# sourceMappingURL=MissingFormat.js.map